import { render, staticRenderFns } from "./CommunityBottom.vue?vue&type=template&id=10b38867&scoped=true"
import script from "./CommunityBottom.vue?vue&type=script&lang=ts"
export * from "./CommunityBottom.vue?vue&type=script&lang=ts"
import style0 from "./CommunityBottom.vue?vue&type=style&index=0&id=10b38867&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b38867",
  null
  
)

export default component.exports